import React, { useEffect, useState } from "react";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
  Button,
  Grid,
  useTheme,
  Tooltip,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
} from "@mui/material";
import { tokens } from "../../../../theme";

export default function ShowVoucherDetails({
  openView,
  vchId,
  handleCloseShow,
  showApproveButton = true,
  showRejectButton = true,
  onApprove = null,
  onReject = null,
}) {
  const token = localStorage.getItem("token");
  const [showInventory, setShowInventory] = useState(true);
  const [showLedger, setShowLedger] = useState(true);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  // Format date from YYYYMMDD to DD-MM-YYYY
  const formatVoucherDate = (dateString) => {
    if (!dateString) return "";

    // If already in correct format, return as is
    if (dateString.includes("-")) return dateString;

    // Format from YYYYMMDD to DD-MM-YYYY
    if (dateString.length === 8) {
      const year = dateString.substring(0, 4);
      const month = dateString.substring(4, 6);
      const day = dateString.substring(6, 8);
      return `${day}-${month}-${year}`;
    }

    return dateString;
  };

  // handle show entry data ==========
  useEffect(() => {
    if (vchId) {
      handleShowData();
    }
  }, [vchId]);

  const [VchData, setVchData] = useState([]);

  const handleShowData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + `/display/voucher`,
        { vchId },
        {
          headers: { Authorization: token },
        }
      );
      const vchData = Object.values(response.data);
      setVchData(vchData[0]);
      console.log("Vch Datails :- ", vchData[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleApprove = () => {
    if (onApprove && vchId) {
      onApprove(vchId);
    }
  };

  const handleReject = () => {
    if (onReject && vchId) {
      if (showRejectButton) {
        setRejectDialogOpen(true);
      }
    }
  };

  const handleRejectConfirm = () => {
    if (onReject && vchId && rejectReason) {
      onReject(vchId, rejectReason);
      setRejectDialogOpen(false);
      setRejectReason("");
    }
  };

  const handleRejectCancel = () => {
    setRejectDialogOpen(false);
    setRejectReason("");
  };

  return (
    <Box id="show-voucher-details">
      <Dialog
        open={openView}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle
          variant="h1"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "1.25rem",
            fontWeight: 700,
            backgroundColor: "#EFE17C",
            color: "#000000",
            padding: "8px 16px",
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            Voucher Details
            {VchData?.is_Cancelled === 1 && (
              <Tooltip title="Cancelled Voucher" arrow>
                <span
                  style={{
                    color: "white",
                    backgroundColor: "red",
                    fontSize: "25px",
                    fontWeight: "bold",
                    border: "1px solid red",
                    borderRadius: "50%",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "30px",
                    height: "30px",
                    cursor: "default",
                  }}
                >
                  C
                </span>
              </Tooltip>
            )}
          </Box>
          <CancelIcon
            sx={{
              cursor: "pointer",
              fontSize: "32px",
              height: "30px",
              width: "30px",
              marginRight: "0px",
              marginTop: "0px",
              color: "#000000",
            }}
            onClick={handleCloseShow}
          />
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            backgroundColor: "#fafafa",
            padding: 1,
          }}
        >
          <Grid container spacing={2} mb={2}>
            <Grid item xs={6}>
              <TextField
                label="Voucher Type"
                value={VchData?.vchType}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Voucher Number"
                value={VchData?.vchNumber}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Voucher Date"
                value={formatVoucherDate(VchData?.vchDate)}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Party Name"
                value={VchData?.partyName}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Voucher Amount"
                value={VchData?.vchAmount}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Narration"
                value={VchData?.narration}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Voucher reference no."
                value={VchData?.reference}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-input": {
                    fontSize: "0.8125rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Grid container spacing={1}>
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => window.open(VchData?.VCHDocument1)}
                    disabled={!VchData?.VCHDocument1}
                    sx={{
                      backgroundColor: "#EFE17C",
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: "0.75rem",
                      padding: "6px 12px",
                      minHeight: "35px",
                      "&:hover": {
                        backgroundColor: "#E6D669",
                        color: "#000000",
                      },
                    }}
                  >
                    Document 1
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => window.open(VchData?.VCHDocument2)}
                    disabled={!VchData?.VCHDocument2}
                    sx={{
                      backgroundColor: "#EFE17C",
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: "0.75rem",
                      padding: "6px 12px",
                      minHeight: "35px",
                      "&:hover": {
                        backgroundColor: "#E6D669",
                        color: "#000000",
                      },
                    }}
                  >
                    Document 2
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => window.open(VchData?.VCHDocument3)}
                    disabled={!VchData?.VCHDocument3}
                    sx={{
                      backgroundColor: "#EFE17C",
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: "0.75rem",
                      padding: "6px 12px",
                      minHeight: "35px",
                      "&:hover": {
                        backgroundColor: "#E6D669",
                        color: "#000000",
                      },
                    }}
                  >
                    Document 3
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box
            display="flex"
            gap={4}
            mb={2}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography sx={{ fontSize: "0.8125rem" }}>
                Show Inventory Entries
              </Typography>
              <Switch
                size="small"
                checked={showInventory}
                color="primary"
                onChange={() => setShowInventory(!showInventory)}
              />
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography sx={{ fontSize: "0.8125rem" }}>
                Show Ledger Entries
              </Typography>
              <Switch
                size="small"
                checked={showLedger}
                color="primary"
                onChange={() => setShowLedger(!showLedger)}
              />
            </Box>
          </Box>

          {showInventory && (
            <>
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#000000",
                }}
              >
                Inventory Entries
              </Typography>

              {VchData?.inventoryentries?.length > 0 ? (
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Item
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Quantity
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Rate
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Amount
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {VchData.inventoryentries.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(even)": { backgroundColor: "#f9f9f9" },
                        }}
                      >
                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          <div>{row.vchiStockItem}</div>
                          <div style={{ marginLeft:"10px", fontSize: "0.75rem", color: "#555" }}>
                            {row.vchidescription?.split(",").map((item, i) => (
                              <div key={i}>{item.trim()}</div>
                            ))}
                          </div>
                        </TableCell>

                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          {row.vchiQty}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          {row.vchiRate}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          {row.vchiAmount}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.8125rem" }}
                >
                  No data found
                </Typography>
              )}
            </>
          )}

          {showLedger && (
            <>
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  mt: 2,
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#000000",
                }}
              >
                Ledger Entries
              </Typography>

              {VchData?.ledgerentries?.length > 0 ? (
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Ledger Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Rate
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          fontSize: "0.8125rem",
                          padding: "8px 12px",
                        }}
                      >
                        Amount
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {VchData.ledgerentries.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(even)": { backgroundColor: "#f9f9f9" },
                        }}
                      >
                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          {row.vchDLedName}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          {row.vchDGstper && `${row.vchDGstper} %`}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "0.8125rem", padding: "6px 12px" }}
                        >
                          {row.vchDLedAmt}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.8125rem" }}
                >
                  No data found
                </Typography>
              )}
            </>
          )}

          {/* Conditionally render buttons based on props */}
          {(showApproveButton || showRejectButton) && (
            <Box
              display="flex"
              justifyContent="end"
              alignItems="center"
              mt={1}
              gap={1}
            >
              {showApproveButton && (
                <Button
                  color="success"
                  variant="contained"
                  size="small"
                  onClick={handleApprove}
                  sx={{
                    backgroundColor: "#4caf50",
                    color: "#ffffff",
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    padding: "6px 12px",
                    "&:hover": {
                      backgroundColor: "#388e3c",
                    },
                  }}
                >
                  Approve
                </Button>
              )}

              {showRejectButton && (
                <Button
                  color="error"
                  variant="contained"
                  size="small"
                  onClick={handleReject}
                  sx={{
                    backgroundColor: "#d32f2f",
                    color: "#ffffff",
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    padding: "6px 12px",
                    "&:hover": {
                      backgroundColor: "#b71c1c",
                    },
                  }}
                >
                  Reject
                </Button>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Reject Reason Dialog */}
      <MuiDialog
        open={rejectDialogOpen}
        onClose={handleRejectCancel}
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <MuiDialogTitle
          sx={{
            fontSize: "1.25rem",
            fontWeight: 700,
            backgroundColor: "#EFE17C",
            color: "#000000",
            padding: "8px 16px",
          }}
        >
          Add Rejection Reason
        </MuiDialogTitle>
        <MuiDialogContent sx={{ padding: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Rejection Reason"
            type="text"
            fullWidth
            variant="outlined"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            multiline
            rows={3}
            size="small"
            sx={{
              "& .MuiInputBase-input": {
                fontSize: "0.8125rem",
              },
            }}
          />
        </MuiDialogContent>
        <MuiDialogActions
          sx={{
            pb: 1,
            pt: 1,
            backgroundColor: "#fafafa",
            padding: "8px 16px",
          }}
        >
          <Button
            onClick={handleRejectCancel}
            size="small"
            sx={{
              backgroundColor: "#d32f2f",
              color: "#ffffff",
              fontWeight: "bold",
              fontSize: "0.75rem",
              padding: "6px 12px",
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleRejectConfirm}
            variant="contained"
            color="error"
            disabled={!rejectReason.trim()}
            size="small"
            sx={{
              backgroundColor: "#EFE17C",
              color: "#000000",
              fontWeight: "bold",
              fontSize: "0.75rem",
              padding: "6px 12px",
              "&:hover": {
                backgroundColor: "#E6D669",
              },
            }}
          >
            Submit Rejection
          </Button>
        </MuiDialogActions>
      </MuiDialog>
    </Box>
  );
}
